import axios from 'axios';

import { getAuthorizationTokens, getExports } from 'services';

const nvMessaging = axios.create({
  timeout: 20000,
});

nvMessaging.interceptors.request.use(
  async request => {
    const endpoints = await getExports();
    request.baseURL = `${endpoints.nvMessagingUrl}`;

    if (!request?.headers?.Authorization) {
      try {
        const { accessToken } = await getAuthorizationTokens();
        if (accessToken) {
          request.headers = {
            ...request.headers,
            Authorization: `Bearer ${accessToken}`,
          };
        }
      } catch {
        // do nothing
      }
    }
    return request;
  },
  error => {
    Promise.reject(error);
  },
);

export { nvMessaging };
